import { storeAuthData } from './auth';
import { updateOnboardingStatus } from '@/api/vercel';

export async function completeSignup(result, plan) {
  if (!result.token || !result.customer?.id || !result.customer?.email) {
    throw new Error('Signup did not return a login session. Please try signing in.');
  }
  if (!['free', 'pro', 'day-pass'].includes(plan)) throw new Error('Please select a plan');
  // Earlier auth-mode servers return a token without an OTP SID. This marker
  // supports that rollout window; the signed token remains the credential.
  const sessionId = result.sid || crypto.randomUUID();
  storeAuthData(sessionId, result.customer.email, null, result.token, 24);
  sessionStorage.removeItem('tempEmail');
  sessionStorage.removeItem('verificationMethod');
  sessionStorage.removeItem('redirectAfterLogin');
  sessionStorage.setItem('selectedPlan', plan);
  if (plan === 'free') {
    await updateOnboardingStatus(result.customer.id, false);
    sessionStorage.setItem('onboarding', 'false');
    localStorage.setItem('onboarding', 'false');
    sessionStorage.removeItem('selectedPlan');
    return '/todays-tips';
  }
  return `/onboard?plan=${plan}`;
}

// Webhooks can arrive after Stripe confirms payment. Keep the session on the
// payment page until the server returns the purchased access, with a retry path.
export async function waitForPaidSession(refresh, delay = ms => new Promise(resolve => setTimeout(resolve, ms))) {
  for (let attempt = 0; attempt < 6; attempt++) {
    if (await refresh(true)) return;
    if (attempt < 5) await delay(1500);
  }
  throw new Error('Payment received. Your access is still being updated. Please retry to enter the app.');
}
